import { gql } from '@apollo/client';

export const PROCESS_IMPORT = gql`
    mutation ProcessImport($input: ProcessImportInput!) {
        processManualImport(input: $input) {
            logId
        }
    }
`;
